import type { Infer } from 'superstruct';
import { array, assign, object, partial, pick } from 'superstruct';

import {
	AddTargetingGeoLocationCountry,
	AddTargetingGeoLocationCustomLocation,
	AddTargetingGeoLocationZip,
	ViewGoogleAdsCampaignLocationTemplateDto,
} from '@adflow/shared/data-google-ads';

import { historyArrayItem } from '../history-array-item';

export const HistoryGoogleAdsLocationDto = partial(
	assign(
		pick(ViewGoogleAdsCampaignLocationTemplateDto, ['id', 'avbId']),
		object({
			locations: partial(
				object({
					custom_locations: array(
						historyArrayItem(partial(AddTargetingGeoLocationCustomLocation))
					),
					zips: array(historyArrayItem(partial(AddTargetingGeoLocationZip))),
					countries: array(
						historyArrayItem(partial(AddTargetingGeoLocationCountry))
					),
				})
			),
		})
	)
);

export type HistoryGoogleAdsLocationDto = Infer<
	typeof HistoryGoogleAdsLocationDto
>;
